
import debounce from "lodash/debounce"
import breadcrumb from "../library/breadcrumb.vue"
import { getDshopData } from "../api/gateway"
import commonConfig from "@/utils/common"
import getCartNumMixin from "@/mixins/getCartNum"
import { getHeadLink, getHeadMeta } from "@/utils/head"
import { getRequestHeaders, parseJSON, appendUrlParams } from "@/utils/utils"
import { Logger } from "@/plugins/logger"
/**
 * 获取URL参数
 */
const getURLParams = ({ query, params }) => {
  const { id, urlPath } = Object.assign(query, params)
  return {
    urlPath: id || urlPath
  }
}

export default {
  components: {
    breadcrumb
  },
  mixins: [getCartNumMixin],
  validate({ query, params }) {
    return query.urlPath || params.id
  },
  async asyncData({ route, req, error, store }) {
    try {
      const { data } = await getDshopData(
        {
          param: getURLParams(route),
          comm: {}
        },
        {
          loading: true,
          headers: getRequestHeaders({ req, store })
        }
      )

      const inspect = data.inspect === "null" ? null : parseJSON(data.inspect)
      const pageData = parseJSON(data.renderData)
      const pageStore = parseJSON(data.renderStore)
      const lang = store.state.lang
      const fullPath = route.fullPath
      return {
        inspect,
        pageData,
        pageStore,
        pageTitle: data?.titleF?.replace(/^\$/, ""),
        pageName: pageData?.settings?.pageName,
        lang: lang == "en_US" ? "en" : "zh-hant",
        fullPath
      }
    } catch (err) {
      Logger.error("dshop初始化报错", err)
      error({
        statusCode: 500,
        message: "Internal Server Error"
      })
    }
  },
  data() {
    return {
      breadcrumbData: [],
      cascaderData: [],
      lang: "",
      fullPath: ""
    }
  },
  head() {
    return {
      title: this.pageTitle,
      meta: [
        { hid: "description", name: "description", content: this.pageTitle },
        { name: "og:type", content: "website" },
        { name: "og:title", content: this.pageTitle },
        { name: "og:description", content: this.pageTitle },
        ...getHeadMeta(this)
      ],
      link: getHeadLink(this)
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.initBreadcrumb()
    },
    initBreadcrumb() {
      const whereFrom = {
        name: this.$t("common.home"),
        path: this.MAIN_ORIGIN_HOME
      }
      const selPath = this.pageName ? [{ name: this.pageName }] : []

      this.breadcrumbData = [whereFrom, ...selPath]
    },
    handleCopyUrl: debounce(function () {
      const urlParams = {
        utm_source: "Share",
        utm_medium: "cs_web",
        utm_campaign: "dshop"
      }
      const url = appendUrlParams(window.location.href, urlParams)
      this.$copyText(url).then(res => {
        this.$message({ message: this.$t("common.shareWithCopyText"), type: "success", duration: 1000 })
      })
    }, 500)
  }
}
